@if (!isLoading) {
  <div>
    <im-items-creation
      [(items)]="items"
      [inspectionId]="inspectionId"
      [itemId]="itemId"
      [defaultFormId]="defaultFormId"
      [allowToDisableSections]="itemsAllowToDisableSections"
      [config]="itemsListConfig"
      >
    </im-items-creation>
  </div>
}
@if (isLoading) {
  <mat-spinner diameter="32"></mat-spinner>
}
